export default __webpack_public_path__ + "static/media/shopping.9e245cab.svg";